// extracted by mini-css-extract-plugin
module.exports = {"label":"_d699686c"};